import React from "react";
import "./About.css";
import Banner from "../Banner/Banner";

const About = () => {
  const highlights = [
    {
      icon: "⚡",
      title: "Built for uptime",
      desc: "Infrastructure and monitoring choices focused on keeping your site reachable when visitors and customers need it.",
    },
    {
      icon: "🛡️",
      title: "Security & SSL",
      desc: "HTTPS by default, sensible isolation on shared platforms, and help with hardening apps and DNS for email.",
    },
    {
      icon: "📈",
      title: "Scale with you",
      desc: "Clear paths from shared hosting to WordPress-optimized plans or VPS when your traffic and complexity grow.",
    },
  ];

  const steps = [
    "Understand your apps, traffic, and compliance needs",
    "Recommend the right hosting tier and backup strategy",
    "Provision, migrate, and verify DNS + SSL together",
    "Stay available for tuning, upgrades, and incidents",
  ];

  return (
    <section className="aboutv6">
      <div className="av6-wrap">
        <div className="av6-top">
          <div className="av6-copy">
            <span className="av6-badge">About us</span>
            <h1 className="av6-title">
              Web hosting you can
              <span> explain to your team</span>
            </h1>
            <p className="av6-sub">
              We’re a hosting provider focused on clarity: honest specs, helpful
              migrations, and support that knows the difference between DNS, SSL,
              and why your WordPress admin suddenly timed out.
            </p>

            <div className="av6-actions">
              <a href="/contact" className="av6-btn av6-btn-primary">
                Contact sales
              </a>
              <a href="/services" className="av6-btn av6-btn-secondary">
                Browse hosting
              </a>
            </div>
          </div>

          <div className="av6-feature-card">
            <div className="av6-feature-grid">
              <div className="av6-mini-card">
                <span>Stack</span>
                <strong>Linux · PHP · MySQL</strong>
              </div>
              <div className="av6-mini-card">
                <span>Also</span>
                <strong>WordPress · VPS · Email</strong>
              </div>
              <div className="av6-mini-card">
                <span>Support</span>
                <strong>Migrations & DNS</strong>
              </div>
              <div className="av6-mini-card">
                <span>Goal</span>
                <strong>Fast, secure, online</strong>
              </div>
            </div>
          </div>
        </div>

        <section className="av6-story">
          <div className="av6-story-card">
            <p className="av6-eyebrow">Our mission</p>
            <h2>Make reliable hosting accessible — without the jargon</h2>
            <p>
              Too many teams wrestle with opaque control panels, surprise DNS
              outages, or “unlimited” plans that buckle under real traffic. We
              aim to be the host that picks up the phone when something breaks
              and explains what happened in plain language.
            </p>
          </div>

          <div className="av6-story-card">
            <p className="av6-eyebrow">How we work</p>
            <ul className="av6-check-list">
              {steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ul>
          </div>
        </section>

        <section className="av6-highlights">
          {highlights.map((item) => (
            <article className="av6-highlight" key={item.title}>
              <div className="av6-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </article>
          ))}
        </section>

        <section className="av6-bottom">
          <div className="av6-bottom-left">
            <p className="av6-eyebrow">Why teams stay</p>
            <h2>Transparent plans, proactive guidance, and real humans</h2>
            <p>
              Whether you’re launching a new project or escaping a bad hosting
              experience, we focus on getting you stable first — then optimizing
              performance and cost as we learn how your site behaves in production.
            </p>
          </div>

          <div className="av6-stats">
            <div className="av6-stat">
              <strong>99.9%</strong>
              <span>uptime target</span>
            </div>
            <div className="av6-stat">
              <strong>24/7</strong>
              <span>support channels</span>
            </div>
            <div className="av6-stat">
              <strong>Global</strong>
              <span>DNS & edge-ready</span>
            </div>
          </div>
        </section>
      </div>

      <Banner />
    </section>
  );
};

export default About;
